// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
async function init() {
  if (process.env.SIMULATION === "true") {
    const { installMockAdapter } =
      await import("./app/DeveloperTools/simulation/mockAdapter");
    installMockAdapter();
  }
  import("./bootstrap").then((bootstrap) => bootstrap.default());
}

init();
